import { LAB_REPORT } from "@/api_framework/api_config";
import {
  ILabReportInterpretationPendingRequisition,
  ILabReportInterpretationPendingRequisitionsResponse,
} from "@/api_framework/api_modals/LabReportInterpretation";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

export const useLabReportInterpretationPendingRequisitionsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (requisitionId: string, testDate: string): Promise<ILabReportInterpretationPendingRequisition[] | null> => {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      return axios
        .get(LAB_REPORT.LAB_REPORT_INTERPRETATION_PENDING_REQUISITIONS.baseURL, {
          params: { requisition_id: requisitionId, test_date: testDate },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ILabReportInterpretationPendingRequisitionsResponse>) => {
          if (res.data?.status === true) return res.data.data ?? [];
          toast.error(res.data?.message || "Unable to fetch pending requisitions");
          return null;
        })
        .catch((e: AxiosError<{ message?: string }>) => {
          sendCurl(e.config?.["curlCommand"]);
          toast.error(e.response?.data?.message || "Unable to fetch pending requisitions");
          return null;
        });
    },
    [],
  );

  return { execute };
};
